export const cssDefaultSource = `/* CSS with vendor prefixes that should be modernized */
.legacy-box {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}

.gradient-background {
  background: -webkit-linear-gradient(top, #ff6b6b, #4ecdc4);
  background: -moz-linear-gradient(top, #ff6b6b, #4ecdc4);
  background: -ms-linear-gradient(top, #ff6b6b, #4ecdc4);
  background: -o-linear-gradient(top, #ff6b6b, #4ecdc4);
  background: linear-gradient(to bottom, #ff6b6b, #4ecdc4);
}

.flex-container {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

/* Modern CSS - should remain unchanged */
.modern-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}`;

export const cssDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";

async function transform(root: SgRoot): Promise<string> {
  const rootNode = root.root();

  // Find vendor-prefixed properties that have standard equivalents
  const vendorPrefixedDeclarations = rootNode.findAll({
    rule: {
      kind: "declaration",
      has: {
        kind: "property_name",
        regex: "^(-webkit-|-moz-|-ms-|-o-)(border-radius|box-shadow|transition|transform|background)"
      }
    }
  });

  const edits = [];

  for (const declaration of vendorPrefixedDeclarations) {
    const propertyNameNode = declaration.find({
      rule: {
        kind: "property_name"
      }
    });

    if (propertyNameNode) {
      const propertyText = propertyNameNode.text();
      
      // Extract standard property name by removing vendor prefix
      let standardProperty = propertyText;
      if (propertyText.startsWith('-webkit-')) {
        standardProperty = propertyText.substring(8);
      } else if (propertyText.startsWith('-moz-')) {
        standardProperty = propertyText.substring(5);
      } else if (propertyText.startsWith('-ms-')) {
        standardProperty = propertyText.substring(4);
      } else if (propertyText.startsWith('-o-')) {
        standardProperty = propertyText.substring(3);
      }
      
      // Check if standard property exists in the same rule block
      const block = declaration.parent(); // Get the containing block
      if (block) {
        const standardExists = block.find({
          rule: {
            kind: "declaration",
            has: {
              kind: "property_name",
              pattern: standardProperty
            }
          }
        });
        
        // If standard property exists, remove the vendor-prefixed version
        if (standardExists) {
          edits.push(declaration.replace(""));
        }
      }
    }
  }

  // Apply all edits
  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const cssDefaultConfig = `
id: remove-redundant-vendor-prefixes
language: css
rule:
  kind: declaration
  has:
    kind: property_name
    regex: "^(-webkit-|-moz-|-ms-|-o-)"
  inside:
    kind: block
    has:
      kind: declaration
      has:
        kind: property_name
        regex: "^(border-radius|box-shadow|transition|transform|background|flex-direction)$"
fix: ""
`.trim();
